import React from 'react';
import './Testimonials.css';

import { Heading } from '../../../components';
import { images, testimonials } from '../../../constants';

import { FaQuoteRight, FaStar } from 'react-icons/fa';

// Import Swiper core and required modules
import { Pagination, Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css'; 
import 'swiper/css/pagination';



const Testimonials = () => {

  return (
    <section className='testimonials'>

      <div className='box-container'>

        <div className='testimonial-slider'>

          {/* Section heading */}
          <Heading title={'Client Testimonials'} subTitle={'What Our Couples Say'} sideHeading />

          <Swiper

            // Install Swiper modules
            modules={[Pagination, Autoplay]} // Enable Pagination & Autoplay
            spaceBetween={10} // Space between slides
            loop={true} // Infinite Looping
            autoplay={{ delay: 4000, disableOnInteraction: false }} // Auto-slide every 4 seconds
            pagination={{ clickable: true }} // Enable pagination dots
            slidesPerView={1} // 1 slide on all screen sizes

          >
            {/* Map over the testiContent array to render each testimonial */}
            {testimonials.map((testimonial) => {

              // Destructure testimonial object
              const { id, image, content, name, title } = testimonial;

              return (
                <SwiperSlide className='testi-item' key={id}>

                  <img src={image} alt={name} /> {/* User Image */}

                  <div className='intro'>

                    <div className='text'>
                      <h4>{name}</h4> {/* Author name */}
                      <h6>{title}</h6> {/* Author title */}
                    </div>

                    <FaQuoteRight className='quote-right' /> {/* Testimonial quote icon */}

                  </div>

                  <p>"{content}"</p> {/* Testimonial */}

                  {/* Author Rating */}
                  <div className="rating">
                    <FaStar className="icon" />
                    <FaStar className="icon" />
                    <FaStar className="icon" />
                    <FaStar className="icon" />
                    <FaStar className="icon" />
                  </div>

                </SwiperSlide>
              );
            })}
          </Swiper>

        </div>

        <div className='image'>
          <img src={images.testimonialImage} alt='Testimonial' />
        </div>

      </div>


    </section>
  );
}

export default Testimonials;